"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSelect = require("react-select");
var _rebrand = require("../../../../icons-react/rebrand");
var DropdownIndicator = exports.DropdownIndicator = function DropdownIndicator(props) {
  var selectProps = props.selectProps;
  var isClearable = selectProps.isClearable;
  return isClearable ? null : /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(StyledChevronDown, null));
};
var StyledChevronDown = (0, _styledComponents["default"])(_rebrand.ChevronDown).withConfig({
  displayName: "DropdownIndicator__StyledChevronDown",
  componentId: "sc-ejt3h5-0"
})(["height:13px;path{fill:var(--grey2);}"]);